import { useEffect, useRef } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { saveEditorDraft, loadEditorDraft } from '../utils/editorDraft.util'

const AUTOSAVE_DELAY = 1500 // זמן דיבאונס לשמירה

export function DraftPlugin() {
  const [editor] = useLexicalComposerContext()
  const timeoutRef = useRef(null)

  // טעינת הטיוטה עם Mount העורך
  useEffect(() => {
    queueMicrotask(() => {
      loadEditorDraft(editor)
    })
  }, [editor])

  // שמירה אוטומטית בהאזנה לעדכונים
  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        saveEditorDraft(editorState)
      }, AUTOSAVE_DELAY)
    })
  }, [editor])

  // ניקוי דיבאונס ב-unmount
  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  return null
}
